import { applyFilters, convertStringToArray, generateErrors } from 'utilities/util';
import { IStore } from 'reducers/index';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { TYPES } from 'action-types/search';
import { TYPES as FILTER_TYPES } from 'action-types/filters';
import { callApiV3Post } from 'utilities/apiCaller';
import API from 'constants/api';
import { TransportMode } from 'constants/modes';

export const fetchSearch = (pageNumber?: number, pageSize?: number, genericSearch?: string) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        const setDefaultFilters = (state:any):any => {
            if(state && state().filters && state().filters.filters){
                const filters = state().filters.filters;
                filters.DocumentType = filters.DocumentType.length === 0? ['Booking', 'CBL', 'EquipmentClr', 'FCR'] :filters.DocumentType;
            }
            return state
        }
        dispatch({ type: TYPES.FETCH_SEARCH_DATA.PENDING });
        try {
            const checkFilter = setDefaultFilters(getState)
            const res = await callApiV3Post(API.Search.GetJobCosting, 
            applyFilters(convertStringToArray(checkFilter, 'DocumentType'),
            {
                isAirInFilters: false,
                isAirInBody: false
            }, {
                Page: pageNumber,
                PageNumber: pageNumber,
                PageSize: pageSize,
                GenericFilter: genericSearch,
            }), { headers: { TransportMode: TransportMode.Ocean } });
            dispatch({ type: FILTER_TYPES.SET_TOTAL_COUNT, totalCount: res.data.totalCount });
            dispatch({ type: TYPES.FETCH_SEARCH_DATA.FULFILLED, response: Object.assign({}, res.data) });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_SEARCH_DATA.REJECTED, errors });
        }
    }
};

export const resetSearch = (pageNumber?: number, pageSize?: number, genericSearch?: string) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.RESET_SEARCH_DATA.PENDING });
        dispatch({ type: FILTER_TYPES.SET_TOTAL_COUNT, totalCount: 0 });
    }
};
